<template>
     <b-card bg-variant="light">
        <b-form-group
            label-cols-sm="3"
            label="Restaurant"
            label-align-sm="right"
            label-for="nested-restaurant"
        >
            {{ restaurantName }}
        </b-form-group>

        <b-form-group
            label-cols-sm="3"
            label="Pickup Number:"
            label-align-sm="right"
            label-for="nested-pickupnumber"
        >

            <b-form-input id="nested-pickupnumber" readonly v-model="pickupNumber"></b-form-input>

        </b-form-group>

        <b-form-group
            label-cols-sm="3"
            label="Phone:"
            label-align-sm="right"
            label-for="nested-phone"
        >
                
            <VuePhoneNumberInput v-model="phone" 
                                 default-country-code="NO"
                                 show-code-on-list
                                 clearable
                                 :only-countries="['NO']"
                                 @update="updatePhoneNumber"
                                 />
        </b-form-group>

        <b-form-group
            label-cols-sm="3"
            label="Customer Name:"
            label-align-sm="right"
            label-for="nested-customername"
        >

            <b-form-input id="nested-customername" 
                :value="customerName"
                @input="updateCustomerName"
            >
            </b-form-input>
        </b-form-group>

        <b-form-group 
            label="Choose Time:" 
            label-cols-sm="3" 
            label-align-sm="right"
            
        >
            <b-form-radio-group
                id="radio-slots"
                v-model="selectedPickupTime"
                :options="pickupTimeOptions"
                name="radio-options-slots"
                @input="pickupTimeChosen"
            >
           
            </b-form-radio-group>
        </b-form-group>

        <b-form-group
            label-cols-sm="3"
            label="Waiting Time:"
            label-align-sm="right"
        >
            <b-form-select id="nested-waitingtime"
                :options="waitingTimeOptions"
                :value="waitingTime"
                @input="updateWaitingTime"
                :disabled="!selectedPickupTime"
            />
        </b-form-group>

        <b-form-group
            label-cols-sm="3"
            label="Pickup Time:"
            label-align-sm="right"
           
        >
            <vue-timepicker 
                :minute-interval="5"
                format="HH:mm"
                :disabled="selectedPickupTime"
                :time-value.sync="pickupTime"
                @change="updatePickupTime"
            >
            </vue-timepicker>
        </b-form-group>

        <b-form-group label="Comment" label-cols-sm="3">
            <b-form-textarea :rows="3"
                :max-rows="6"
                @input="updateComment"
                :value="comment">
            </b-form-textarea>
        </b-form-group>
        
    </b-card>
</template>

<script>
import { mapState, mapGetters } from'vuex'
import VueTimepicker from 'vue2-timepicker'
import TimeFormatter from '../../../src/assets/js/TimeFormatter'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
    components: {
        VueTimepicker,
        VuePhoneNumberInput
    },
    computed: {
        ...mapState({
            pickupNumber: state => state.ordersbyphonecontrol.cart.pickupNumber,
            restaurantName : state => state.ordersbyphonecontrol.restaurantName,
            customerName : state => state.ordersbyphonecontrol.cart.customerName,
            phoneNumber: state => state.ordersbyphonecontrol.cart.phoneNumber,
            comment : state => state.ordersbyphonecontrol.cart.comment,
            waitingTime : state => state.ordersbyphonecontrol.cart.waitingTime,
            pickupTime : state => state.ordersbyphonecontrol.cart.pickupTime
        })
    },
    methods : {

        updateCustomerName(e) {

            this.$store.commit('ordersbyphonecontrol/updateCustomerNameState', e);

        },

        updatePhoneNumber(e) {
            if (e.isValid) {
                this.$store.commit('ordersbyphonecontrol/updatePhoneNumberState', e.nationalNumber);
            }
            this.$store.commit('ordersbyphonecontrol/updateIsPhoneValidState', e.isValid);
        },

        updateComment(e) {
            this.$store.commit('ordersbyphonecontrol/updateCommentState', e);
        },

        updateWaitingTime(e) {
            this.$store.commit('ordersbyphonecontrol/setCurrentWaitingTimeState', e);
        },

        updatePickupTime(e) {
            this.$store.commit('ordersbyphonecontrol/setCurrentWaitingTimeState', e);
        },

        pickupTimeChosen(e) {
            if (this.selectedPickupTime) {
                this.$store.commit('ordersbyphonecontrol/setCurrentWaitingTimeState', 20);
            }
            else {
                this.$store.commit('ordersbyphonecontrol/setCurrentWaitingTimeState', 0);
            }
        },
        updatePickupTime(e) {

            let time = {
                'HH' : e.data.HH,
                'mm' : e.data.mm,
                'ss' : '00'
            };
            this.$store.commit('ordersbyphonecontrol/setPickupTimeState', time);
            
        }
        
    },
    data () {
        return {
            waitingTimeOptions: [
                {value: 5, text: '5 minutes'},
                {value: 10, text: '10 minutes'},
                {value: 15, text: '15 minutes'},
                {value: 20, text: '20 minutes'},
                {value: 25, text: '25 minutes'},
                {value: 30, text: '30 minutes'},
                {value: 35, text: '35 minutes'},
                {value: 40, text: '40 minutes'},
                {value: 45, text: '45 minutes'},
                {value: 50, text: '50 minutes'},
                {value: 55, text: '55 minutes'},
                {value: 60, text: '60 minutes'}
            ],
            selectedPickupTime : true,
            pickupTimeOptions : [
                {text: 'Pickup time', value: true },
                {text: 'Other time', value : false }
            ],
            phone : ''

        }
    }
}
</script>